module.exports = __webpack_public_path__ + "img/job-light-manual.8f32f2d5.svg";